import { render, staticRenderFns } from "./properties-block-container.vue?vue&type=template&id=bc066fec&scoped=true"
import script from "./properties-block-container.vue?vue&type=script&lang=js"
export * from "./properties-block-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc066fec",
  null
  
)

export default component.exports